import { Provider } from '@angular/core';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { Platform } from '@mnz-core/models/_enums';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { isEmbedded } from '@mnz-shared/shared.constants';

declare interface MyExtendedWindow extends Window {
  /* Relay42 default properties  */
  BASE_RELAY_TAG_PROPERTIES: {
    preview: boolean;
    nsenvironment: any;
    language: any;
  };

  /* IAppConfiguration, properties come from the server  */
  config: any;
}

const extendedWindow = (window as Window) as MyExtendedWindow;

export function appConfigurationFactory(): IAppConfiguration {
  let lang = document.documentElement.lang;

  // in embedded mode (used by NS App login) the browser language is also used
  if (isEmbedded() && navigator.language.startsWith('en')) {
    lang = 'en';
  }

  return {
    ...extendedWindow.config,
    relay42_config: {
      preview: false,
      nsenvironment: Platform.DEVELOPMENT,
      language: lang
    }
  };
}

export function provideAppConfiguration(): Provider {
  return {
    provide: APP_CONFIG,
    useFactory: appConfigurationFactory
  };
}
